import React, { useState } from "react";

const FranchiseAgreement = () => {
  const [formData, setFormData] = useState({
    date: "",
    year: "",
    franchiseeName: "",
    associateCode: "",
    area: "",
    zone: "",
    termStart: "",
    termEnd: "",
    franchiseFee: "",
    franchiseFeeWords: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="max-w-4xl mx-auto p-8 bg-white shadow-lg print:shadow-none">
      {/* Header */}
      <div className="text-center mb-8">
        <h1 className="text-xl font-bold underline mb-4">
          AGREEMENT FOR APPOINTMENT OF FRANCHISEE
        </h1>
      </div>

      {/* Agreement Introduction */}
      <div className="mb-6">
        <p className="mb-4">
          THIS AGREEMENT is made on this{" "}
          <input
            type="text"
            name="date"
            value={formData.date}
            onChange={handleInputChange}
            className="border-b border-gray-400 px-2 py-1 print:border-black"
            placeholder="date"
          />
          , 20
          <input
            type="text"
            name="year"
            value={formData.year}
            onChange={handleInputChange}
            className="border-b border-gray-400 px-2 py-1 w-12 print:border-black"
            placeholder="YY"
          />
          , BETWEEN M/s{" "}
          <strong>Lims Speciality Laboratory Pvt. Ltd.,</strong>
        </p>

        <div className="relative mb-4">
          <p>at 12, Indra Biswas Road, Kolkata-700037</p>
          <div className="absolute top-5 right-5 w-32 h-32 border border-black flex items-center justify-center text-xs text-center print:border-black bg-white">
            <div>
              <p>AFFIX</p>
              <p>STAMP SIZE</p>
              <p>PHOTOGRAPH</p>
              <p>HERE</p>
            </div>
          </div>
        </div>

        <p className="mb-2">(hereinafter referred to as the FRANCHISOR)</p>
        <p className="mb-2">
          which expression shall unless the context requires otherwise include
          its
        </p>
        <p className="mb-4">successors) of the FIRST PART.</p>

        <p className="mb-4 font-bold">AND</p>

        <p className="mb-2">Mr. ....................................</p>
        <p className="mb-2">
          (hereinafter referred to as the FRANCHISEE which expression shall
          unless the context requires otherwise include
        </p>
        <p className="mb-4">its successors) of the SECOND PART.</p>

        <p className="mb-4">
          WHERE AS the company is carrying on business as Laboratory in the
          above mentioned address in the jurisdiction of Kolkata.
        </p>

        <p className="mb-6">
          AND WHERE AS the Second part has approached the First Part and
          requested the First Part to grant/appoint him as a Franchisee in the
          business conducted by the First Part for the period of three years and
          further in order to enable persons to get the benefit in the
          Franchisor's business on behalf of the First Part as commission basis
          only.
        </p>

        <div className="mb-4">
          <p>
            Associate Code for the SECOND PART{" "}
            ..................................
          </p>
        </div>

        <div className="mb-6">
          <p>Regarding Area:</p>
          ...........................................
        </div>
      </div>

      {/* Terms and Conditions */}
      <div className="space-y-4">
        <div>
          <p className="mb-4">
            <strong>1.</strong> AND WHERE AS the Franchisee further declared
            before first part that he is not working for and in any other
            Company like their business and he intends to work as Franchisee to
            collect blood testing samples as an independent contractor in the
            Franchisor's business in the territory which will be allotted to him
            by the First Part on request of the Second Part, the first part
            agreed to appoint the second part as their Franchisee on terms and
            conditions mentioned hereinafter.
          </p>
          <p className="mb-4">
            The Parties herein have mutually agreed to the terms and conditions
            in the manner hereinafter given below:
          </p>
        </div>

        <div>
          <p className="mb-4">
            <strong>2.</strong> The Company hereby appoint the Franchisee as the
            agent of the company in the ( .............................. ) zone
            for the collection of testing samples for a terms of 3 (three) years
            commencing from ........................... to{" "}
            .................................... .
          </p>
        </div>

        <div>
          <p className="mb-4">
            <strong>3.</strong> The Franchisee shall deposit a post dated
            account payee Cash/Demand Draft for the sum of Rs.
            ......................... (
            ...........................................................................................
            ) only as a Franchisee Fees and the same amount shall be refundable
            on the termination of this agreement subject to settlement of
            accounts and if the franchisee failed & neglected to settle the
            account the security deposit shall be treated as a part payment made
            by the franchisee in discharge of his liabilities and / or debts.
          </p>
        </div>

        <div>
          <p className="mb-4">
            <strong>4.</strong> If the Franchisee fails to make any payment of
            any amount under this agreement to the Franchisor within the periods
            herein/if this agreement is terminated either by efflux of time or
            by sooner determination thereof, if any amounts is due and
            outstanding or becomes due or outstanding from the franchisee, then
            without prejudice to any rights of the franchisor under this
            agreement, the franchisor shall be entitled to receive/claim such
            amount from the Franchisee along with interest @24% per annum.
          </p>
        </div>

        <div>
          <p className="mb-2">
            <strong>5)</strong> Franchisee shall-
          </p>
          <div className="ml-4 space-y-2">
            <p>
              <strong>a)</strong> Use his endeavors to promote and expand his
              capability to collect testing samples from surround (hereinafter
              called the Territory) to obtain order thereof.
            </p>
            <p>
              <strong>b)</strong> Act loyally and faithfully and obey the orders
              and instructions of the first part and if in any case it is not
              possible to obtain instruction in a particular matter to act in
              such a manner as the interest of the first part.
            </p>
            <p>
              <strong>c)</strong> Not to take order or collect any sample which
              he knows or has reason to believe an intended to collect outside
              his jurisdiction without prior consent of the First Part.
            </p>
            <p>
              <strong>d)</strong> Not neither to make any representation at the
              time of collections of samples nor to give any guarantee without
              written consent from the First Part.
            </p>
            <p>
              <strong>e)</strong> Keep proper books of accounts and records of
              all enquiries and transaction relating such business and submit
              report from time to time to the First Part and authorized officer
              to inspect and take copies of such books of accounts and records.
            </p>
            <p>
              <strong>f)</strong> Not to take excess price for any kind of test
              or tests which is mentioned on the price list of the First Part
              and if the Second Part take excess price then he shall be solely
              responsible for that and in that case this agreement shall be
              revoked by the First Part.
            </p>
          </div>
        </div>

        {/* Technology and Email Terms */}
        <div>
          <p className="mb-2">
            <strong>6.</strong> The First Part for Expeditious delivery of the
            report of the company adopted the modern technology for sending the
            report through Email / Internet on the following terms & conditions:
          </p>
          <div className="ml-4 space-y-2">
            <p>
              <strong>a)</strong> The Second Part after getting the report
              through Email / Internet print the same after down load and in the
              instant case he shall have the right to only print and he has no
              right to alter and / or amend the report and if he changes any
              thing in that case he is found guilty and he shall be solely
              responsible for that.
            </p>
            <p>
              <strong>b)</strong> The Second Part who is availing such Email /
              Internet facility and for this the First Part shall not supply the
              copy of said report through courier except Histopathology report
              through courier to the Second Part.
            </p>
            <p>
              <strong>c)</strong> The First Part shall provide the printing
              stationery paper and / or Report Pad to the second part and in the
              said paper front portion shall be blank for printing the report
              and in the back side of the paper the usual terms & conditions of
              the company / First Part shall be mentioned.
            </p>
            <p>
              <strong>d)</strong> The Second Part shall use the said report pad
              only for downloading the report which shall be supplied by the
              First Part and he shall have no right to use for any other purpose
              and if he uses he shall be prosecuted under the Indian Penal Code
              and/or any other Law for the time being enforce.
            </p>
            <p>
              <strong>e)</strong> The Second Part for availing such facility
              shall arrange own computer and for this he shall maintain privacy
              and in case of leakage any report by any Third Party the Second
              Part shall be solely responsible for that.
            </p>
            <p>
              <strong>f)</strong> The INTERNET generated report from Lims
              Speciality Laboratory Pvt. Ltd. of 12,Indra Biswas Road, will be
              preserve for Ten (10) days from the date of Emailing of such
              report.
            </p>
          </div>
        </div>

        {/* Additional Terms */}
        <div>
          <p className="mb-4">
            <strong>7.</strong> The Second Part shall not assign, transfer or
            change his right under these presents in all correspondences and
            documents in relations to the tests shall describe himself as the
            Franchisee of the first Part.
          </p>
        </div>

        <div>
          <p className="mb-4">
            <strong>8.</strong> The Franchisee agrees and convinces that the
            Franchisee shall not act as the Franchisee for any other company
            like Lims Speciality Laboratory Pvt. Ltd. within the allotted
            /specified territory during continuance of the present agreement
          </p>
        </div>

        <div>
          <p className="mb-4">
            <strong>9.</strong> The First Part shall supply to the second Part
            test catalogues, Rate, Chart, Bill book as the company consider
            reasonably sufficient with a view to enable Franchisee to
            conveniently render to patient parties in the said territory.
          </p>
        </div>

        <div>
          <p className="mb-4">
            <strong>10.</strong> Notwithstanding anything to the contrary
            contained herein the Company reserve to its right to transfer and
            assign its rights and obligations under the Agreement to any other
            person after giving 15 days notice to Second Part.
          </p>
        </div>

        <div>
          <p className="mb-4">
            <strong>11.</strong> It is agree that if in the reasonable opinion
            of the Franchisor, the Franchisee is not adequate to collect samples
            through the said territory; the Franchisor may exclude a portion of
            the area or otherwise vary the extent of the territory on prior
            notice to the Franchisee.
          </p>
        </div>

        {/* Cancellation Terms */}
        <div>
          <p className="mb-2">
            <strong>12.</strong> Cancellation of Franchisee:
          </p>
          <div className="ml-4 space-y-1">
            <p>
              <strong>i)</strong> On his resignation from Franchisee addressed
              to the Managing Director,
            </p>
            <p>
              <strong>ii)</strong> On his becoming in sense or insolvent;
            </p>
            <p>
              <strong>iii)</strong> On his conviction of any offence in
              connection with the criminal cases / proclaimed offender,
            </p>
            <p>
              <strong>iv)</strong> In default in paying the subscription
              collected from the parties or paying bills for continuance of
              three months;
            </p>
            <p>
              <strong>v)</strong> On using the false name and goodwill of the
              Company (First Part);
            </p>
            <p>
              <strong>vi)</strong> The Company can cancel the Franchise giving
              the notice of 7 days if found the Franchisee is acting against the
              interest of the first part.
            </p>
            <p>
              <strong>vii)</strong> On default of any clause of this agreement
              Franchisee can be cancelled.
            </p>
            <p>
              <strong>viii)</strong> The first part shall have power to make
              such bye-law, rules and regulations as may be considered necessary
              in the interest of the business.
            </p>
            <p>
              <strong>ix)</strong> In default of not generating the minimum
              business volume worth Rs.20,000/- per month, your authorization of
              franchisee may be terminated by our authority/management as per
              organization's rule.
            </p>
          </div>
        </div>

        {/* Remaining terms 13-33 */}
        <div className="space-y-4">
          <p>
            <strong>13)</strong> After termination of this agreement the second
            part shall at his own expenses promptly return to the First Part all
            catalogues advertising materials, bills book, specification to the
            business of the company, which the franchisee might have in this
            possession or under his control.
          </p>

          <p>
            <strong>14)</strong> The waiver by the Company of any breach of any
            of the terms of this agreement shall not prevent the subsequent
            enforcement of that term and shall not be deemed a waiver of any
            subsequent breach.
          </p>

          <p>
            <strong>15)</strong> The Franchisee hereby agrees and admits that
            Franchisee shall alone be held responsible in respect of any suit,
            application or any legal proceedings or whatsoever nature or any
            complaint filed by any person or any Authority in any court,
            tribunal, forum, commission or before any authority, pertaining to
            conduct of any incidents at the Franchisee's Centre, any dispute
            between party/patient(s) and the Franchisee or in respect of any
            matter related to or concerning the Franchisee's center and the
            Franchisor or its Directors or officials shall not held responsible
            and made party to any suit, complaint or any legal proceedings
            related to or in respect of any matters of the Franchisee's center.
          </p>

          <p>
            <strong>16)</strong> The Franchisee shall indemnify and keep
            indemnified at all the times the Franchisor of, from and against all
            actions, Suits or proceedings and all costs, charges, expenses,
            losses or damages which may be incurred, suffered or caused by or to
            the Franchisor by reason of any suit, application or any other legal
            proceedings or complaint filed by any person against the Franchisor
            or its directors and its officials in any court, tribunal, forum,
            commission or before any Authority, pertaining to or in respect of
            any matter of the Franchisee's Centre.
          </p>

          <p>
            <strong>17)</strong> The entire costs of running a center, including
            acquisition of space, engaging of personnel and all other
            expenditure shall be borne and paid by the Franchisee only and the
            franchisee shall not be entitled to require the Franchisor to share
            any part or portion of such expenditure or reimburse any part
            thereof.
          </p>

          <p>
            <strong>18)</strong> It is hereby expressly agreed to between the
            parties hereto in writing that the persons employed by the
            franchisee at the Franchisee's center are the employees of the
            Franchisee only and none of them shall be entitled to claim any
            status as the employee of the franchisor.
          </p>

          <p>
            <strong>19)</strong> It is further clarified and understood that the
            Franchisee alone shall be responsible, liable for any non compliance
            of any legislation / liability which is necessary for running of the
            franchisee centre.
          </p>

          <p>
            <strong>20)</strong> The Franchisee shall recruit well qualified
            person as to his/her qualification, experience, technical expertise,
            skills and other requirements necessary in the opinion of the
            franchisor in order to ensure that the Franchisee's staff and
            personnel employed in connection with the work training have
            adequate technical expertise and qualifications, skills, experience,
            integrity and reliability so as to maintain high quality and
            standards in the Franchisee's Centre.
          </p>

          <p>
            <strong>21)</strong> The Franchisee shall in its operation of the
            Franchisee's center adhere to the strictest standards of cleanliness
            and the Franchisee shall maintain the premises in a neat and clean
            condition and shall require its employees in the performance of
            their duties to wear neat and clean uniforms when prescribed by time
            Franchisor.
          </p>

          <p>
            <strong>22)</strong> It is clarified and understood that the
            Franchisee alone shall be responsible, liable for any samples send
            by them to the First Part during the transit till the First Part
            received of such samples.
          </p>

          <p>
            <strong>23)</strong> The Franchisee disclaim any right or interest
            in Franchisor trade marks, trade names, service names or marks and
            the logos and designs and all advantages and benefits derived there
            from and the technical know-how and Training Resources Materials.
          </p>

          <p>
            <strong>24)</strong> The Franchisor shall have the right to
            terminate this Agreement forthwith in the event that the franchisee
            questions, disputes or attacks the validity, right, title or
            interest of the Franchisor as to the Franchisor's trade marks, trade
            names, service names and marks and designs.
          </p>

          <p>
            <strong>25)</strong> The parties hereto agree that the Franchisee is
            an independent contractor. Nothing herein contained shall constitute
            the Franchisee as agent, legal representative, partner, subsidiary,
            joint venture or employee of the Franchisor.
          </p>

          <p>
            <strong>26)</strong> The Franchisee shall not collect blood samples
            after the termination of the Agreement on behalf of the Franchisor.
          </p>

          <p>
            <strong>27)</strong> In the event of the death of the Franchisee,
            the Franchisor may at its opinion either treat this agreement as
            having been terminated by such reason or permit any of the heirs of
            the Franchisee, as may be selected by the Franchisor, to continue in
            the place of the deceased as the Franchisee for the purpose of
            agreement subject to such person executing such documents as may be
            stipulated by the Franchisor in this regard.
          </p>

          <p>
            <strong>28)</strong> The Franchisee hereby agrees that he shall give
            all cooperation to the Franchisor for the conduct of their business
            as herein provided and shall not in any manner obstruct the
            franchisor.
          </p>

          <p>
            <strong>29)</strong> In addition to other rights herein or under the
            law, the First Part shall have the right to at any time to give
            notice in writing to the Franchisee termination to agreement
            forthwith if the Franchisee commits a breach of any of the terms
            herein or it does any act of insolvency or the Franchisee is
            prevented from performing his duties hereunder for any reason
            whatsoever or the Franchisee is guilty of any conduct prejudicial in
            the interest of the First Part.
          </p>

          <p>
            <strong>30)</strong> This agreement shall be renewable after the
            expiry of stipulated period of time on the terms and conditions
            which might be mutually agreed upon between the parties.
          </p>

          <p>
            <strong>31)</strong> It is further agreed in between the parties if
            the Second Part fails to deposit the amount and/or share of the
            First Part at 25,Indra Biswas Road,Kolkata-700037 and for such act
            he shall be liable for misappropriating the Fund of the First Part
            for that he shall be liable prosecuted under Indian Penal Code
            and/or any other Law for the time being in force in Kolkata.
          </p>

          <p>
            <strong>32)</strong> The Kolkata Court shall be exclusive
            Jurisdiction over the matter any kinds of disputes and differences
            etc. between the parties.
          </p>

          <p>
            <strong className="underline">
              33. Any discrepancy of the above mentioned area will be noticed
              the Franchisee ship then there will be terminated.
            </strong>
          </p>
        </div>
      </div>

      {/* Signature Section */}
      <div className="mt-12">
        <p className="mb-6">
          IN WITNESS WHEREOF the parties have executed the present on the day,
          month and year first above written signed, sealed and delivered by:-
        </p>

        <p className="mb-8 font-bold">SIGNED, SEALED & DELIVERED</p>
        <p className="mb-8">In the presence of:-</p>

        <div className="flex justify-between items-start">
          <div className="w-1/2">
            <div className="mb-6">
              <p className="font-bold">MRS. ARPITA BANERJEE</p>
              <p>(Proprietor)</p>
              <div className="border-b border-black w-48 mt-4"></div>
              <p className="mt-2 font-bold">F I R S T P A R T</p>
            </div>
          </div>

          <div className="w-1/2 flex flex-col items-center">
            <div className="w-32 h-32 border border-black flex items-center justify-center text-xs text-center mb-4">
              <div>
                <p>AFFIX</p>
                <p>STAMPSIZE</p>
                <p>PHOTOGRAPH</p>
                <p>HERE</p>
              </div>
            </div>
            <div className="border-b border-black w-48 mb-2"></div>
            <p className="font-bold">S E C O N D P A R T</p>
          </div>
        </div>

        <div className="mt-12">
          <p className="mb-4">Witness:</p>
          <div className="space-y-4">
            <p>1. ________________________</p>
            <p>2. ________________________</p>
          </div>
        </div>
      </div>

      {/* Print Button */}
      <div className="mt-8 print:hidden">
        <button
          onClick={handlePrint}
          className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700 transition-colors"
        >
          Print Agreement
        </button>
      </div>
    </div>
  );
};

export default FranchiseAgreement;
